import { Collection, } from "@bluelibs/x-ui";
import { AgenciesTag } from "@root/api.types";
import { UsersCollection, AgenciesCollection, } from "@bundles/UIAppBundle/collections";
export class AgenciesTagsCollection extends Collection {
    getName() {
        return "AgenciesTags";
    }
    getInputs() {
        return {
            insert: "AgenciesTagInsertInput!",
            update: "AgenciesTagUpdateInput!",
        };
    }
    // Return here the relations with other configs
    getLinks() {
        return [
            {
                collection: () => UsersCollection,
                name: "createdBy",
                field: "createdById",
            },
            {
                collection: () => UsersCollection,
                name: "updatedBy",
                field: "updatedById",
            },
            {
                collection: () => AgenciesCollection,
                name: "agencies",
            },
        ];
    }
    // Return here how you want to transform certain fields
    getTransformMap() {
        return {
            createdAt: (v) => (v && new Date(v) ? new Date(v) : v),
            updatedAt: (v) => (v && new Date(v) ? new Date(v) : v),
        };
    }
}
